module.exports = "/img/og_image_alt.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/og_image_alt.jpg
// module id = 448
// module chunks = 0